module.exports = __webpack_public_path__ + "static/media/Camada_5.a73f2903.svg";